module.exports = __webpack_public_path__ + "img/aaa.sample.068bcbff.png";